import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export default class WritingLegendsCourseProgressController extends Controller {
  queryParams = ['sort', 'pageNumber', 'perPage']

  @tracked sort = 'first_name'

  @tracked pageNumber = 1

  @tracked perPage = 10
}

declare module '@ember/controller' {
  interface Registry {
    'reporting/ui-scope/writing-legends/course-progress': WritingLegendsCourseProgressController
  }
}
